import { GRADIENTS, LAYOUT } from '../styles/tokens';

/** 4px gradient accent bar (gold → cyan → navy) */
export function Lightbar(): React.JSX.Element {
  return (
    <div
      style={{
        height: `${LAYOUT.lightbarHeight}px`,
        background: GRADIENTS.lightbar,
        flexShrink: 0,
      }}
    />
  );
}
